import { gql } from '@apollo/client';

export const QUOTE_CREATE = gql`
  mutation quoteCreate($userId: ID!, $quote: String!) {
    quoteCreate(userId: $userId, quote: $quote) {
      payload {
        _id
        by
        quote
        createdAt
        updatedAt
      }
      token
      message
      status
    }
  }
`;

export const QUOTE_UPDATE = gql`
  mutation quoteUpdate($quoteId: ID!, $quote: String!) {
    quoteUpdate(quoteId: $quoteId, quote: $quote) {
      payload {
        _id
        by
        quote
        createdAt
        updatedAt
      }
      token
      message
      status
    }
  }
`;

export const QUOTE_DELETE = gql`
  mutation quoteDelete($quoteId: ID!) {
    quoteDelete(quoteId: $quoteId) {
      payload {
        _id
        by
        quote
        createdAt
        updatedAt
      }
      token
      message
      status
    }
  }
`;
